"use client";

import { useState } from "react";
import { AnimatedItem } from "@/components/componentAnimation/animatedItemComponent";
import styles from "./HelpSection.module.css";
import StudentAffairsContactsModal, {
  StudentAffairsContact,
} from "@/components/student-life/StudentAffairsContactsModal/StudentAffairsContactsModal";

type HelpSectionProps = {
  title: string;
  buttonText: string;
  modalTitle: string;
  contactsLabel: string;
  contacts: StudentAffairsContact[];
};

export default function HelpSection({
  title,
  buttonText,
  modalTitle,
  contactsLabel,
  contacts,
}: HelpSectionProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <AnimatedItem>
        <section className={styles.helpSection}>
          <div className={styles.helpOverlay}>
            <h2 className={styles.helpTitle}>{title}</h2>

            <button
              type="button"
              onClick={openModal}
              className={styles.helpBtn}
            >
              {buttonText}
            </button>
          </div>
        </section>
      </AnimatedItem>

      <StudentAffairsContactsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={modalTitle}
        contactsLabel={contactsLabel}
        contacts={contacts}
      />
    </>
  );
}
